
import { ReactNode } from "react";

interface AdminAccessProps {
  children: ReactNode;
}

// Versão "liberada": sempre renderiza os filhos e não faz nenhuma restrição
export const AdminAccess = ({ children }: AdminAccessProps) => {
  return <>{children}</>;
};
